import { Box } from '@palmetto/palmetto-components';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const hiddenProperties = ['currentMilestone', 'requirements', 'milestones'];

const SabalAccountUpdated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> updated
      <br />
      <Diffs diff={event?.data?.diff} hiddenProperties={hiddenProperties} />
    </Box>
  );
};

export default SabalAccountUpdated;
